export default function Terms() {

  return (

    <div className="container-narrow">

      <div className="card">

        <h1>Terms of Use</h1>

        <p>

          By accessing or using Hopeful Horizons NY, you agree to use the platform for lawful purposes only.

        </p>

        <p>

          Hopeful Horizons NY provides a directory of independent service providers. We do not employ providers listed on the site and do not guarantee the quality, availability, or suitability of services.

        </p>

        <p>

          Families and participants are responsible for verifying credentials, experience, and compatibility prior to engaging any provider.

        </p>

        <p>

          Hopeful Horizons NY is not responsible for service outcomes, scheduling agreements, or disputes between users and providers.

        </p>

        <p>

          We reserve the right to update these terms at any time.

        </p>

      </div>

    </div>

  );

}